import set from 'lodash/set'

const messages = {}

const files = require.context('@/assets/messages/', true, /\.json/)
files.keys().forEach((key) => {
  const path = key.replace(/(\.\/|\.json)/g, '').replace(/(\/)/g, '.')

  set(messages, path, files(key))
})

export default messages



// WEBPACK FOOTER //
// ./src/i18n/messages.js